import { Box, Card, Grid, Typography } from '@mui/material'
import HeaderGestorConfigs from '../../../utils/headerGestorConfigs'
import DateHora from '../../../utils/dateHora'
import TextoFormatado from '../../../utils/textoFormatado';
import Date from '../../../utils/date';
import Genero from '../../../utils/genero';
// import StatusSolicitacoes from '../../../utils/status/statusSolicitacoes';
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup';
import { useState } from 'react';
import MessageSuccess from '../../../messages/messageSuccess';
import MessageError from '../../../messages/messageError';
import api from '../../../services/api';
import { useSelector } from 'react-redux';

export default function FichaSolicitacaoAnalise({ solicitacaoAnalise }) {
    const user = useSelector(state => state.account.user);
    const [editDados, setEditDados] = useState('');
    const [isEditFicha, setIsEditFicha] = useState(false);
    const [isEditRemetente, setIsEditRemetente] = useState(false);
    const [isEditResponsavel, setIsEditResponsavel] = useState(false);
    const [load, setLoad] = useState(false);
    const [messageSuccess, setMessageSuccess] = useState('');
    const [messageError, setMessageError] = useState('');


    const submitEdit = async () => {

        setLoad(true)
        setMessageSuccess('')
        setMessageError('')

        await api.put('/solicitacao-analise/edit', { ...editDados, 'solicitacaoAnaliseId': solicitacaoAnalise._id, 'userId': user?._id ?? '' })
            .then(res => {
                // console.log(editDados)
                // setDadosEmpresa(res.data.empresa)
                // setRefresh(res.data.empresa)
                setLoad(false)
                // setMessageSuccess(res.data.msg)
                setIsEditFicha(false);
                setIsEditRemetente(false);
                setIsEditResponsavel(false);

            }).catch(err => {
                // console.log(err)
                setLoad(false)
                setMessageError(err.response.data.message)
            })
    }


    return (
        <>
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}

            <Card style={{ padding: 20, marginBottom: 10 }}>

                <HeaderGestorConfigs
                    menu={false}
                    configArea={''}
                    title={'SOLICITAÇÃO DE ANÁLISE'}
                />

                <Grid xs item>
                    <InfoFieldGroup
                        submit={submitEdit}
                        data={editDados}
                        // handleChange={handleChange}
                        setIsEdit={setIsEditFicha}
                        isEdit={isEditFicha}
                        load={load}
                        fields={
                            [
                                { label: 'Estado', value: solicitacaoAnalise?.status, editable: false, },
                                { label: 'Número de registo', value: solicitacaoAnalise?.numero, key: 'nome', editable: false, onChange: (v) => setEditDados({ ...editDados, numero: v.target.value }) },
                                { label: 'Solicitado por', value: solicitacaoAnalise?.remetidoPor?.nome, key: 'remetidoPorNome', onChange: (v) => setEditDados({ ...editDados, remetidoPorNome: v.target.value }) },
                                { label: 'Nº de identificação', value: solicitacaoAnalise?.remetidoPor?.bi, key: 'remetidoPorBi', onChange: (v) => setEditDados({ ...editDados, remetidoPorBi: v.target.value }) },
                                { label: 'Tipo de remetente', value: solicitacaoAnalise?.tipoRemetente, key: 'tipoRemetente', onChange: (v) => setEditDados({ ...editDados, tipoRemetente: v.target.value }) },
                                { label: 'Quantidade de produtos', value: solicitacaoAnalise?.productos?.length, key: 'quantidadeProdutos', onChange: (v) => setEditDados({ ...editDados, quantidadeProdutos: v.target.value }) },
                                { label: 'Grau de urgência', value: solicitacaoAnalise?.grauUrgencia ?? 'Urgente', editable: false, key: 'grauUrgencia', onChange: (v) => setEditDados({ ...editDados, grauUrgencia: v.target.value }) },
                                { label: 'Data de Solicitação', value: <DateHora date={solicitacaoAnalise.createdAt} />, editable: false, type: 'date', key: 'dataSolicitacao', onChange: (v) => setEditDados({ ...editDados, dataSolicitacao: v.target.value }) },
                            ]
                        } />
                </Grid>
            </Card>

            <Card style={{ padding: 20, marginBottom: 10 }}>

                <HeaderGestorConfigs
                    menu={false}
                    configArea={''}
                    title={'DADOS DO REMETENTE'}
                />

                <InfoFieldGroup
                    submit={submitEdit}
                    data={editDados}
                    // handleChange={handleChange}
                    setIsEdit={setIsEditRemetente}
                    isEdit={isEditRemetente}
                    load={load}
                    fields={
                        [
                            { label: 'Tipo de Remetente', value: solicitacaoAnalise?.tipoRemetente, key: 'tipoRemetente', editable: false, onChange: (v) => setEditDados({ ...editDados, tipoRemetente: v.target.value }) },
                            { label: 'Nome', value: solicitacaoAnalise?.nome, key: 'nome', onChange: (v) => setEditDados({ ...editDados, nome: v.target.value }) },
                            { label: 'NIF/BI', value: solicitacaoAnalise?.nifBi, key: 'nifBi', onChange: (v) => setEditDados({ ...editDados, nifBi: v.target.value }) },
                            { label: 'Email', value: solicitacaoAnalise?.email, key: 'email', onChange: (v) => setEditDados({ ...editDados, email: v.target.value }) },
                            { label: 'Telefone', value: solicitacaoAnalise?.tel, key: 'tel', onChange: (v) => setEditDados({ ...editDados, tel: v.target.value }) },
                            { label: 'Província', value: solicitacaoAnalise?.provincia, key: 'provincia', editable: false, onChange: (v) => setEditDados({ ...editDados, provincia: v.target.value }) },
                            { label: 'Município', value: solicitacaoAnalise?.municipio, key: 'municipio', editable: false, onChange: (v) => setEditDados({ ...editDados, municipio: v.target.value }) },
                            { label: 'Bairro', value: solicitacaoAnalise?.bairro, key: 'bairro', onChange: (v) => setEditDados({ ...editDados, bairro: v.target.value }) },
                            { label: 'Rua', value: solicitacaoAnalise?.rua, key: 'rua', onChange: (v) => setEditDados({ ...editDados, rua: v.target.value }) },

                            ...(solicitacaoAnalise?.estabelecimento ? [
                                {
                                    label: 'Estabelecimento',
                                    value: solicitacaoAnalise.estabelecimento?.nome,
                                    key: 'estabelecimentoNome',
                                    editable: false,
                                    // onChange: v => setEditDados({ ...editDados, estabelecimentoNome: v.target.value })
                                },
                                {
                                    label: 'NIF do Estabelecimento',
                                    value: solicitacaoAnalise.estabelecimento.nif,
                                    key: 'estabelecimentoNif',
                                    editable: false,
                                    // onChange: v => setEditDados({ ...editDados, estabelecimentoNif: v.target.value })
                                },
                                {
                                    label: 'Número do Processo',
                                    value: solicitacaoAnalise.estabelecimento.numeroProcesso,
                                    key: 'estabelecimentoNumeroProcesso',
                                    editable: false,
                                    // onChange: v => setEditDados({ ...editDados, estabelecimentoNumeroProcesso: v.target.value })
                                }
                            ] : [])
                        ]

                    } />
            </Card>


            {/* Nova seção: Dados do Responsável */}
            <Card style={{ padding: 20, marginBottom: 10 }}>

                <HeaderGestorConfigs
                    menu={false}
                    configArea={''}
                    title={'DADOS DO RESPONSÁVEL'}
                />

                <InfoFieldGroup
                    submit={submitEdit}
                    data={editDados}
                    // handleChange={handleChange}
                    setIsEdit={setIsEditResponsavel}
                    isEdit={isEditResponsavel}
                    load={load}
                    fields={
                        [
                            { label: 'Nome do Responsável', value: solicitacaoAnalise?.remetidoPor?.nome, key: 'nome', onChange: (v) => setEditDados({ ...editDados, remetidoPorNome: v.target.value }) },
                            { label: 'BI do Responsável', value: solicitacaoAnalise?.remetidoPor?.bi, key: 'remetidoPorBi', onChange: (v) => setEditDados({ ...editDados, remetidoPorBi: v.target.value }) },
                            { label: 'Telefone do Responsável', value: solicitacaoAnalise?.remetidoPor?.tel, key: 'remetidoPorTel', onChange: (v) => setEditDados({ ...editDados, remetidoPorTel: v.target.value }) },
                            { label: 'Email do Responsável', value: solicitacaoAnalise?.remetidoPor?.email, key: 'remetidoPorEmail', onChange: (v) => setEditDados({ ...editDados, remetidoPorEmail: v.target.value }) },
                            { label: 'Data de Nascimento', value: solicitacaoAnalise?.remetidoPor?.dataNascimento ? <Date date={solicitacaoAnalise.remetidoPor.dataNascimento} /> : 'Não informado', key: 'remetidoPorDataNascimento', editable: false, onChange: (v) => setEditDados({ ...editDados, remetidoPorDataNascimento: v.target.value }) },
                            { label: 'Gênero', value: <Genero genero={solicitacaoAnalise?.remetidoPor?.genero} />, key: 'remetidoPorGenero', editable: false, onChange: (v) => setEditDados({ ...editDados, remetidoPorGenero: v.target.value }) },
                        ]
                    } />
            </Card>

            <Card >
                <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', }}>
                    <Typography style={{ lineHeight: 1.5 }} variant="subtitle1"><strong>Justificativa:</strong> <TextoFormatado texto={solicitacaoAnalise?.justificativa ?? '####'} /></Typography>
                </Box>
            </Card>
        </>
    )
}
